module.exports = __webpack_public_path__ + "static/img/rule.6a5782b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/rule.png
// module id = 6d3P
// module chunks = 1 3